import { createFileRoute } from "@tanstack/react-router";

import { SpVisitFormPage } from "@/components/features/SpVisitForm/SpVisitFormPage";

// SERV-3046: public, token-gated page. A service provider opens it from a text with no
// session, so it has no auth guard and sits outside the app shell; every API call it makes
// goes through the bare public client.
export const Route = createFileRoute("/sp-visit-form/$token/")({
  component: SpVisitFormRoute,
});

function SpVisitFormRoute() {
  const { token } = Route.useParams();
  return <SpVisitFormPage token={token} />;
}
